<nav class="navbar navbar-expand-lg bg-primary navbar-transparent navbar-absolute" color-on-scroll="500">
  <div class="container">
    <div class="navbar-wrapper">

    </div>


  </div>
</nav>
  <router-outlet></router-outlet>
